import Head from "next/head";
import Link from "next/link";
import MainLayout from "../../components/layouts/MainLayout";
import Hero from "../../components/Hero";
import Container from "../../components/Container";
import SectionFloating from "../../components/sections/SectionFloating";
import Badge from "../../components/Badge";
import SectionJobsCta from "../../components/sections/SectionJobsCta";
import {generateTitle} from "../../helpers/meta";

import imageHeroDesktop from "../../public/img/hero/intern_desktop.jpg";
import imageHeroMobile from "../../public/img/hero/intern_mobile.jpg";
import {useRouter} from "next/router";
import localized from "../../locale/locales";
import Title from "../../components/Title";
import SectionJobsUs from "../../components/sections/SectionJobsUs";
import SectionJobsYou from "../../components/sections/SectionJobsYou";


export default function PartTimeJobInAmsterdam() {
    const {locale} = useRouter();
    const {amsterdam: lang} = localized[locale];

    return (
        <MainLayout overflow={true}>
            <Head>
                <title key="title">{generateTitle(lang.og.title)}</title>
                <meta key="og:title" property="og:title" content={generateTitle(lang.og.title)}/>
                <meta key="description" name="description" content={lang.og.description}/>
                <meta key="og:description" property="og:description" content={lang.og.description}/>
            </Head>

            <div className="w-screen absolute h-full overflow-hidden -mt-[100px] pt-[100px]">
                <SectionFloating scheme="part-time-job-in-amsterdam"/>
            </div>

            <div className="w-screen overflow-hidden">
                <Hero direction="image-left"
                      imageDesktop={imageHeroDesktop}
                      imageMobile={imageHeroMobile}
                      className="relative items-end gap-6 lg:gap-10 lg:pt-5"
                >
                    <div className="flex flex-col gap-7 md:gap-5 md:pb-10">
                        <div className="flex flex-col gap-5 accent-orange-800">
                            {/*<div>*/}
                            {/*    <Badge>{lang.header.badge}</Badge>*/}
                            {/*</div>*/}
                            <header>
                                <Title Elem="h1">
                                    {lang.header.title.localize({emoji: '💼'})}
                                </Title>
                            </header>
                            <div className="flex flex-col gap-8">
                                <p className="leading-[1.8] max-w-[45ch]">
                                    {lang.header.body}
                                </p>
                                <Link href="/programmes/jobs-in-the-netherlands">
                                    <a className="text-accent-color underline mouse-hover:no-underline">
                                        {lang.header.cta}
                                    </a>
                                </Link>
                            </div>
                        </div>
                    </div>
                </Hero>
            </div>

            <Container className="relative">
                <div className="flex flex-col-reverse gap-14 lg:flex-row lg:items-start pt-16 md:pt-28 pb-12 lg:pb-20">
                    <SectionJobsUs/>
                    <SectionJobsYou/>
                </div>
            </Container>

            <SectionJobsCta form="summer"/>
        </MainLayout>
    )
}